
<v-dialog
    persistent
    width   = "500"
    v-model = "show"
    v-if    = "message"
>
    <v-card>
        <v-card-title class="message-title" v-html="$t(message.id + '.title', message.parameter)" v-if="message.id.title">
        </v-card-title>

        <v-card-subtitle class="message-subtitle primary--text">
            Hinweis:
        </v-card-subtitle>
        <v-card-text class="message-text" v-html="$t(message.id + '.message', message.parameter)">
        </v-card-text>

        <v-card-actions>
            <v-spacer  />

            <v-btn
                v-if="message.action"
                color="primary"
                @click="onCase"
                text
            >
                {{ $t(message.id + ".action") }}
            </v-btn>

            <v-btn
                text
                color="primary"
                @click="onCancel"
            >
                Schließen
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
